import { request } from "../request";
import { request2 } from "../request2";

export const getTradeList = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/getAllListing',
		params
	})
}
export const modifyDatafeedOutputStatus = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/modifyDatafeedOutputStatus',
		params
	})
}
export const modifyListingEnableStatus = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/modifyListingEnableStatus',
		params
	})
}
export function getElasticResult(words,category="allWines") {
	const params={
		words:encodeURIComponent(words),
		category
	}
	return request2({
        method: 'post',
        url:"new/elastic",
				params
    })
}
export const getWineDbList = (params) => {
	return request({
		method: 'post',
		url: process.env.REACT_APP_DB_API+'/wine/page',
		params
	})
}
export const getBlacklist = (params) => {
	return request2({
		method: 'post',
		url: '/blacklist/getAll',
		params
	})
}

export const AddBlacklist = (params) => {
	return request2({
		method: 'post',
		url: '/blacklist/add',
		params
	})
}
export const RemoveBlacklist = (params) => {
	return request2({
		method: 'post',
		url: '/blacklist/remove',
		params
	})
}